import React from 'react';
import { Menu, Bell } from 'lucide-react';
import { Link } from 'react-router-dom';
interface HeaderProps {
  onMenuClick?: () => void;
}
export function Header({
  onMenuClick
}: HeaderProps) {
  return <header className="bg-white border-b border-gray-200 sticky top-0 z-30 h-16 flex items-center justify-between px-4 lg:px-8" data-id="element-26">
      {/* Left: Hamburger Menu (Mobile only) + Logo */}
      <div className="flex items-center gap-4" data-id="element-27">
        {onMenuClick && <button onClick={onMenuClick} className="lg:hidden p-2 hover:bg-gray-100 rounded-lg transition-colors" data-id="element-28">
            <Menu size={24} className="text-gray-600" data-id="element-29" />
          </button>}

        {/* Logo on mobile */}
        <img src="https://cdn.magicpatterns.com/uploads/8cgjy9xZXMMnHXpfCScj2x/cleanai_b2b.png" alt="CleanAI B2B" className="h-6 lg:hidden" data-id="element-30" />
      </div>

      {/* Right: Notifications + Avatar */}
      <div className="flex items-center gap-3 ml-auto" data-id="element-31">
        {/* Notification Bell - Links to /richieste */}
        <Link to="/richieste" className="relative p-2 hover:bg-gray-50 rounded-lg transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" data-id="element-32">
          <Bell size={20} className="text-gray-600" data-id="element-33" />
          <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] bg-red-500 rounded-full border-2 border-white flex items-center justify-center" data-id="element-34">
            <span className="text-[10px] font-bold text-white" data-id="element-35">3</span>
          </span>
        </Link>

        {/* User Avatar - Hidden on small mobile */}
        <div className="hidden sm:flex items-center gap-3 hover:bg-gray-50 rounded-lg p-2 transition-colors cursor-pointer" data-id="element-36">
          <img src="https://ui-avatars.com/api/?name=Pulizie+Express&background=0d9488&color=fff&size=32" alt="Profilo" className="w-8 h-8 rounded-full border border-gray-200" data-id="element-37" />
          <div className="text-left hidden lg:block" data-id="element-38">
            <p className="text-sm font-semibold text-navy" data-id="element-39">Pulizie Express</p>
            <p className="text-xs text-gray-500" data-id="element-40">info@pulizieexpress.it</p>
          </div>
        </div>

        {/* Mobile: Just avatar */}
        <button className="sm:hidden p-2 hover:bg-gray-50 rounded-lg transition-colors min-h-[44px] min-w-[44px] flex items-center justify-center" data-id="element-41">
          <img src="https://ui-avatars.com/api/?name=Pulizie+Express&background=0d9488&color=fff&size=32" alt="Profilo" className="w-8 h-8 rounded-full border border-gray-200" data-id="element-42" />
        </button>
      </div>
    </header>;
}